<template>
    <transition name="fade-in-up">
        <router-view></router-view>
    </transition>
</template>

<script>
    export default {
        name: "Exam"
    }
</script>

<style scoped>

</style>